export default __webpack_public_path__ + "static/media/Jodi Passport Picture 2.80d95c5c.png";